import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { isInsideEditor } from '@dotcms/client';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { GenerateLazyComponent } from 'ish-core/utils/module-loader/generate-lazy-component.decorator';

import { DotCmsFacade } from '../../facades/dot-cms.facade';
import { getDotCmsPageLoading } from '../../store/dotcms-pages/dotcms-page.selector';

@Component({
  selector: 'custom-dot-cms-default-page',
  templateUrl: './dot-cms-default-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@GenerateLazyComponent()
export class DotCmsDefaultPageComponent implements OnInit, OnDestroy {
  dotCMSLoading$: Observable<boolean>;

  constructor(private store: Store, private dotcmsFacade: DotCmsFacade) {}

  ngOnInit() {
    this.dotCMSLoading$ = this.store.pipe(select(getDotCmsPageLoading));
  }
  ngOnDestroy(): void {
    if (isInsideEditor()) this.dotcmsFacade.DOT_CMS_CLIENT.editor.off('changes');
  }
}
